import PropTypes from 'prop-types'
import { Component } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { connect } from 'react-redux'
import Selectors from '../../../selectors'
import { history } from '../../../store'
import { withRouter } from '../../../withRouter'

export class RedirectHandler extends Component {
  componentDidMount() {
    this.handleRedirect(this.props)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.handleRedirect(nextProps)
  }

  handleRedirect(props) {
    const {
      selectedResident,
      location: { prev },
      router
    } = props
    const isMobile = !isBrowser && !isTablet
    if (router.params.id || isMobile) return
    if (
      prev &&
      prev.match(/\/residents\/.*/) &&
      !prev.match(/profile\/edit$/)
    ) {
      history.back()
      return
    }
    if (prev === '/residents') return
    if (selectedResident) {
      this.redirect()
    }
  }

  redirect = () => {
    history.push(`/residents/list`)
  }

  render() {
    return null
  }
}

RedirectHandler.propTypes = {
  selectedResident: PropTypes.string
}

const mapStateToProps = (state) => ({
  selectedResident: Selectors.chooseSelectedResident(state),
  location: state.global.location
})

export default withRouter(connect(mapStateToProps, null)(RedirectHandler))
